<app-client-info></app-client-info>

<app-table (parentFunc)="tableRowFunc($event)" [sizeOptions]="sizeOptions" [Title]="tableTitle" [Collection]="inboxCollection" [displayedColumns]="displayedColumns"></app-table>
